const TokenKey = 'cntbToken'
export default {
    getToken: function () {
        // debugger
        return localStorage.getItem(TokenKey)
    },
    setToken: function (token) {
        return localStorage.setItem(TokenKey, token)
    },
    // setuuid: function (uuid) {
    //     return localStorage.setItem("uuid", uuid)
    // },
    // getuuid: function () {
    //     return localStorage.getItem("uuid")
    // },
    removeToken: function () {
        localStorage.removeItem("jz_username");
        localStorage.removeItem("jz_relname");
        localStorage.removeItem("jz_cmpid");
        localStorage.removeItem("jz_roles");
        localStorage.removeItem("jz_menus");
        localStorage.removeItem("jz_userid");
        localStorage.removeItem(TokenKey);
        localStorage.removeItem("jz_type");
        localStorage.removeItem("jz_incmpid");
    },
    objSetToken: function (entity) {
        entity.sessionToken = this.getToken();
        entity.token=this.getToken();
    },
    gettype() {
        return localStorage.getItem("jz_type");
    },
    
    getusername() {
        return localStorage.getItem("jz_username");
    },
    getrelname() {
        return localStorage.getItem("jz_relname");
    },
    getcmpid() {
        return localStorage.getItem("jz_cmpid");
    },
    getincmpid() {
        return localStorage.getItem("jz_incmpid");
    },
    getRoles() {
        return JSON.parse(localStorage.getItem("jz_roles"));
    },
    getMenus() {
        return JSON.parse(localStorage.getItem("jz_menus"));
    },
    getinfo() {
        return JSON.parse(localStorage.getItem('jz_info'))
      },
    setinfo(obj) {
        // return Cookies.set(TokenKey, token)
        return localStorage.setItem('jz_info', JSON.stringify(obj))
      }
};



// WEBPACK FOOTER //
// ./src/utils/auth.js